import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import { ProductInventoryLotsTab } from "@/screens/Inventory/subfeatures/ProductInventory/components"
import { productInventoryLotsSearchSchema } from "@/screens/Inventory/subfeatures/ProductInventory/schemas"

export const Route = createFileRoute("/app/inventory/products/$productId/_layout/lots")({
  validateSearch: zodValidator(productInventoryLotsSearchSchema),
  component: () => <ProductInventoryLotsTab />,
})
